import { render, staticRenderFns } from "./HomeNewOrEdit.vue?vue&type=template&id=0db57edc&scoped=true&"
import script from "./HomeNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./HomeNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewOrEdit.vue?vue&type=style&index=0&id=0db57edc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db57edc",
  null
  
)

export default component.exports